import { render } from "./SiteFooterNavigationSection.vue?vue&type=template&id=589b6c96&scoped=true"
import script from "./SiteFooterNavigationSection.vue?vue&type=script&lang=js"
export * from "./SiteFooterNavigationSection.vue?vue&type=script&lang=js"

import "./SiteFooterNavigationSection.vue?vue&type=style&index=0&id=589b6c96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589b6c96"]])

export default __exports__